<template>
  <v-card flat color="transparent">
    <v-card-text class="text-center text-h4" id="skills">Skills</v-card-text>
    <v-card
      flat
      color="transparent"
      class="mx-auto"
      width="60%"
      v-if="!$vuetify.breakpoint.mobile"
    >
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col cols="4" v-for="(skill, index) in skills" :key="index">
            <v-card color="transparent" width="150" class="mx-auto" flat>
              <v-card-text class="text-center">
                <v-icon color="orange" style="font-size: 70px">{{ skill.icon }}</v-icon>
                <br />
                {{ skill.title }}
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text class="text-center">{{ skill.text }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div v-if="$vuetify.breakpoint.mobile">
      <v-card
        color="transparent"
        width="50%"
        class="mx-auto"
        flat
        v-for="(skill, index) in skills"
        :key="index"
      >
        <v-card-text class="text-center">
          <v-icon color="orange" style="font-size: 70px">{{ skill.icon }}</v-icon>
          <br />
          {{ skill.title }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="text-center">{{ skill.text }}</v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      skills: [
        {
          icon: "mdi mdi-code-braces",
          title: "Languages",
          text: "HTML, Javascript, CSS, PHP, Java, C++",
        },
        {
          icon: "mdi mdi-cube",
          title: "Data Frameworks",
          text: "Pillow",
        },
        {
          icon: "mdi mdi-laptop",
          title: "Frameworks",
          text: "Vue.js, Laravel, Cordova",
        },
        {
          icon: "mdi mdi-database-cog",
          title: "Databases",
          text: "MySQL, FireStore, Firebase Realtime DB, OracleSQL",
        },
        {
          icon: "mdi mdi-hammer-wrench",
          title: "Operating systems & Tools",
          text: "Windows, MacOs, Linux, Heroku, Firebase",
        },
        {
          icon: "mdi mdi-monitor-edit",
          title: "Design",
          text: "Canva, Adobe XD, ShotCut",
        },
      ],
    };
  },
};
</script>

<style></style>
